const STORAGE_KEY = 'claim_load_criteria';

export interface ClaimLoadCriteria {
  maxPage?: number;
  createdAt?: {
    from?: string | Date;
    to?: string | Date;
  };
  claim_id?: {
    from?: string | number;
    to?: string | number;
  };
}

const DEFAULT_CRITERIA: ClaimLoadCriteria = {
  maxPage: 1,
};

export const getDefaultClaimLoadCriteria = (): ClaimLoadCriteria => {
  return { ...DEFAULT_CRITERIA };
};

export const saveClaimLoadCriteria = (criteria: ClaimLoadCriteria) => {
  try {
    const payload: ClaimLoadCriteria = {
      ...DEFAULT_CRITERIA,
      ...criteria,
    };

    if (payload.createdAt) {
      payload.createdAt = {
        from: normalizeDateForStorage(payload.createdAt.from),
        to: normalizeDateForStorage(payload.createdAt.to),
      };
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (err) {
    console.warn('Failed to save claim load criteria', err);
  }
};

export const getClaimLoadCriteria = (): ClaimLoadCriteria => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return getDefaultClaimLoadCriteria();
    }
    const parsed = JSON.parse(stored);
    return {
      ...DEFAULT_CRITERIA,
      ...parsed,
    };
  } catch (err) {
    console.warn('Failed to read claim load criteria', err);
    return getDefaultClaimLoadCriteria();
  }
};

export const clearClaimLoadCriteria = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.warn('Failed to clear claim load criteria', err);
  }
};

const normalizeDateForStorage = (value?: string | Date) => {
  if (!value) {
    return undefined;
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  const date = new Date(value);
  return isNaN(date.getTime()) ? undefined : date.toISOString();
};

